// 星与页面
const Home = () => import(/* webpackChunkName: 'index' */ '@/views/index/home.vue') //首页
const HomeListArtist = () => import(/* webpackChunkName: 'index-list-artist' */ '@/views/index/list/artist.vue') //首页-艺人列表
const HomeListAmbassador = () =>
  import(/* webpackChunkName: 'index-list-ambassador' */ '@/views/index/list/ambassador.vue') //首页-品牌代言
const HomeListActive = () => import(/* webpackChunkName: 'index-list-active' */ '@/views/index/list/active.vue') //首页-明星福利活动
const HomeListRankEndorsement = () =>
  import(/* webpackChunkName: 'index-list-rank-endorsement' */ '@/views/index/list/rank/endorsement.vue') //首页-代言榜单
const HomeListRankEndorsementTest = () =>
  import(/* webpackChunkName: 'index-list-rank-endorsement-test' */ '@/views/index/list/rank/endorsementTest.vue') //首页-代言榜单test
const HomeDetailBrand = () => import(/* webpackChunkName: 'index-detail-brand' */ '@/views/index/detail/brand.vue') //首页-品牌-详情
const HomeDetailEndorsementWeek = () =>
  import(/* webpackChunkName: 'index-detail-endorsement-week' */ '@/views/index/detail/endorsement/week.vue') //首页-代言-一周官宣
const HomeDetailEndorsementMonth = () =>
  import(/* webpackChunkName: 'index-detail-endorsement-month' */ '@/views/index/detail/endorsement/month.vue') //首页-代言-月度盘点
const HomeDetailRankEndorsementVolume = () =>
  import(
    /* webpackChunkName: 'index-detail-rank-endorsement-volume' */ '@/views/index/detail/rank/endorsement/volume.vue'
  ) //首页-榜单-声量详情页
const HomeDetailRankEndorsementAmount = () =>
  import(
    /* webpackChunkName: 'index-detail-rank-endorsement-amount' */ '@/views/index/detail/rank/endorsement/amount.vue'
  ) //首页-榜单-数量盘点详情页
const HomeDetailRankStarfire = () =>
  import(/* webpackChunkName: 'index-detail-rank-starfire' */ '@/views/index/detail/rank/starfire/detail.vue') //首页-榜单-星火指数排行榜详情页
const HomeDetailRankStarfireRule = () =>
  import(/* webpackChunkName: 'index-detail-rank-starfire-rule' */ '@/views/index/detail/rank/starfire/rule.vue') //首页-榜单-星火排行榜规则
const HomeDetailRankFlame = () =>
  import(/* webpackChunkName: 'index-detail-rank-flame' */ '@/views/index/detail/rank/flame/detail.vue') //首页-榜单-粉丝火苗热力榜详情页
const HomeDetailRankFlameRule = () =>
  import(/* webpackChunkName: 'index-detail-rank-flame-rule' */ '@/views/index/detail/rank/flame/rule.vue') //首页-榜单--粉丝火苗热力榜规则
// 社区
const CommunityIndex = () => import(/* webpackChunkName: 'community-index' */ '@/views/community/index.vue') //社区&应援社区
const CommunityUserHome = () => import(/* webpackChunkName: 'community-user-home' */ '@/views/community/user/home.vue') //社区-用户主页
const CommunityPublishDaily = () =>
  import(/* webpackChunkName: 'community-publish-daily' */ '@/views/community/publish/daily.vue') //社区-发布日常
const CommunityPublishImageReturn = () =>
  import(/* webpackChunkName: 'community-publish-image-return' */ '@/views/community/publish/imageReturn.vue') //社区-发布返图
const CommunityPublishActivityRegistration = () =>
  import(
    /* webpackChunkName: 'community-publish-activity-registration' */ '@/views/community/publish/activityRegistration.vue'
  ) //社区-发布活动报名
const CommunityPublishImageCollection = () =>
  import(/* webpackChunkName: 'community-publish-return-image' */ '@/views/community/publish/imageCollection.vue') //社区-发布返图征集
const CommunityPublishCreativeCollection = () =>
  import(
    /* webpackChunkName: 'community-publish-creative-collection' */ '@/views/community/publish/creativeCollection.vue'
  ) //社区-发布创意征集
const CommunityPublishVote = () =>
  import(/* webpackChunkName: 'community-publish-vote' */ '@/views/community/publish/vote.vue') //社区-发布投票评选
const CommunityPublishNewRecruit = () =>
  import(/* webpackChunkName: 'community-publish-new-recruit' */ '@/views/community/publish/newRecruit.vue') //社区-发布新人招募
const CommunityPublishLotteryDraw = () =>
  import(/* webpackChunkName: 'community-publish-lottery-draw' */ '@/views/community/publish/lotteryDraw.vue') //社区-发布抽奖
const CommunityPostDetailActivityRegistration = () =>
  import(
    /* webpackChunkName: 'community-post-detail-activity-registration' */ '@/views/community/post/detail/activityRegistration.vue'
  ) //社区-活动报名详情页
const CommunityPostDetailImageCollection = () =>
  import(
    /* webpackChunkName: 'community-post-detail-return-image' */ '@/views/community/post/detail/imageCollection.vue'
  ) //社区-返图征集详情页
const CommunityPostDetailImageReturn = () =>
  import(/* webpackChunkName: 'community-post-detail-return-image' */ '@/views/community/post/detail/imageReturn.vue') //社区-返图详情页
const CommunityPostDetailDaily = () =>
  import(/* webpackChunkName: 'community-post-detail-daily' */ '@/views/community/post/detail/daily.vue') //社区-日常帖子详情页
const CommunityPostDetailCreativeCollection = () =>
  import(
    /* webpackChunkName: 'community-post-detail-creative-collection' */ '@/views/community/post/detail/creativeCollection.vue'
  ) //社区-创意征集详情页
const CommunityPostDetailVote = () =>
  import(/* webpackChunkName: 'community-post-detail-vote' */ '@/views/community/post/detail/vote.vue') //社区-投票详情页
const CommunityPostDetailNewRecruit = () =>
  import(/* webpackChunkName: 'community-post-new-recruit' */ '@/views/community/post/detail/newRecruit.vue') //社区-新人招募详情页
const CommunityPostDetailLotteryDraw = () =>
  import(/* webpackChunkName: 'community-post-lottery-draw' */ '@/views/community/post/detail/lotteryDraw.vue') //社区-抽奖页
const CommunityAuditActivityRegistration = () =>
  import(
    /* webpackChunkName: 'community-audit-activity-registration' */ '@/views/community/audit/activityRegistration.vue'
  ) //社区-活动审核页
const CommunityAuditImageReturn = () =>
  import(/* webpackChunkName: 'community-audit-image-return' */ '@/views/community/audit/imageReturn.vue') //社区-返图审核页
const CommunityAuditCreativeCollection = () =>
  import(/* webpackChunkName: 'community-audit-creative-Collection' */ '@/views/community/audit/creativeCollection.vue') //社区-创意征集审核页
const CommunityAuditNewRecruit = () =>
  import(/* webpackChunkName: 'community-audit-new-recruit' */ '@/views/community/audit/newRecruit.vue') //社区-新人招募审核页
const CommunityPostListActivityRegistration = () =>
  import(
    /* webpackChunkName: 'community-post-list-activity-registration' */ '@/views/community/post/list/activityRegistration.vue'
  ) //报名列表
const CommunityPostListImageCollection = () =>
  import(
    /* webpackChunkName: 'community-post-list-image-collection' */ '@/views/community/post/list/imageCollection.vue'
  ) //返图列表
const CommunityGrandceremony = () =>
  import(/* webpackChunkName: 'community-grandceremony' */ '@/views/community/h5/grandceremony.vue') //社区盛典门票抽奖兑换
// 个人中心
const PersonalCenter = () => import(/* webpackChunkName: 'personal-center' */ '@/views/personal/center.vue') //个人中心
const PersonalAccountSetting = () =>
  import(/* webpackChunkName: 'personal-account-setting' */ '@/views/personal/account/setting.vue') //个人中心-账号设置
const PersonalMyActive = () => import(/* webpackChunkName: 'personal-my-active' */ '@/views/personal/my/active.vue') //个人中心-我的活动
const PersonalMySubscribe = () =>
  import(/* webpackChunkName: 'personal-my-subscribe' */ '@/views/personal/my/subscribe.vue') //个人中心-我的订阅
const PersonalMyCelebrities = () =>
  import(/* webpackChunkName: 'personal-my-celebrities' */ '@/views/personal/my/celebrities.vue') //个人中心-我的圈子
const PersonalMyPhoto = () => import(/* webpackChunkName: 'personal-my-photo' */ '@/views/personal/my/photo.vue') //个人中心-我的合影
const PersonalMyStarlight = () =>
  import(/* webpackChunkName: 'personal-my-starlight' */ '@/views/personal/my/starlight.vue') //个人中心-我的星辉
const PersonalNotification = () =>
  import(/* webpackChunkName: 'personal-notification' */ '@/views/personal/notification/list.vue') //个人中心-通知中心
const PersonalNotificationSubscribe = () =>
  import(/* webpackChunkName: 'personal-notification-subscribe' */ '@/views/personal/notification/subscribe.vue') //个人中心-新增订阅
const PersonalNotificationLike = () =>
  import(/* webpackChunkName: 'personal-notification-like' */ '@/views/personal/notification/like.vue') //个人中心-收到点赞
const PersonalNotificationComment = () =>
  import(/* webpackChunkName: 'personal-notification-comment' */ '@/views/personal/notification/comment.vue') //个人中心-收到留言
// 明星Ai合影
const AiIndex = () => import(/* webpackChunkName: 'ai-index' */ '@/views/ai/index.vue') //首页
const AiTemplate = () => import(/* webpackChunkName: 'ai-template' */ '@/views/ai/template.vue') //模板
const AiCreate = () => import(/* webpackChunkName: 'ai-create' */ '@/views/ai/create.vue') //生成合影
const AiFinish = () => import(/* webpackChunkName: 'ai-finish' */ '@/views/ai/finish.vue') //完成合影
const AiTest = () => import(/* webpackChunkName: 'ai-test' */ '@/views/ai/test.vue') //测试页面
// common（other页）
const Test = () => import(/* webpackChunkName: 'test' */ '@/views/other/test.vue') //测试页面
const Search = () => import(/* webpackChunkName: 'search' */ '@/views/other/search.vue') //搜索页面
const UserAgreement = () => import(/* webpackChunkName: 'user-agreement' */ '@/views/other/legal/userAgreement.vue')
const PrivacyPolicy = () => import(/* webpackChunkName: 'privacy-policy' */ '@/views/other/legal/privacyPolicy.vue')
const Layouts = () => import(/* webpackChunkName: 'layouts' */ '@/layouts/page.vue')
const Error404 = () => import(/* webpackChunkName: 'error404' */ '@/views/other/404.vue') //404
const BusinessInfoBind = () => import(/* webpackChunkName: 'business-infobind' */ '@/views/other/businessInfoBind.vue') //商务信息绑定页面
const UserList = () => import(/* webpackChunkName: 'user-list' */ '@/views/other/userList.vue') //用户列表页面
// 艺人页面
const Artist = () => import(/* webpackChunkName: 'artist' */ '@/views/artist/home.vue') //艺人主页
// 艺人-列表页
const ListHotspot = () => import(/* webpackChunkName: 'list-hotspot' */ '@/views/list/hotspot.vue') //艺人-热点事件
const ListAmbassador = () => import(/* webpackChunkName: 'list-ambassador' */ '@/views/list/ambassador.vue') //艺人-品牌代言
const ListMovieTv = () => import(/* webpackChunkName: 'list-movietv' */ '@/views/list/movietv.vue') //艺人-影视剧
const ListMusic = () => import(/* webpackChunkName: 'list-music' */ '@/views/list/music.vue') //艺人-音乐
const ListVariety = () => import(/* webpackChunkName: 'list-variety' */ '@/views/list/variety.vue') //艺人-综艺
const ListImageText = () => import(/* webpackChunkName: 'list-imageText' */ '@/views/list/imageText.vue') //艺人-图文
const ListBusiness = () => import(/* webpackChunkName: 'list-business' */ '@/views/list/business.vue') //艺人-商务活动
const ListBusinessRelate = () =>
  import(/* webpackChunkName: 'list-business-relate' */ '@/views/list/relate/business.vue') //艺人-商务活动列表(品牌代言相关)
const ListHonor = () => import(/* webpackChunkName: 'list-honor' */ '@/views/list/honor.vue') //艺人-荣誉成就
const ListCharity = () => import(/* webpackChunkName: 'list-charity' */ '@/views/list/charity.vue') //艺人-社会公益
const ListAlbum = () => import(/* webpackChunkName: 'list-album' */ '@/views/list/album.vue') //艺人-图集
// const ListCase = () => import(/* webpackChunkName: 'list-case' */ '@/views/list/case.vue')
// const ListNew = () => import(/* webpackChunkName: 'list-new' */ '@/views/list/new.vue')
// 艺人-详情页
const Detail = () => import(/* webpackChunkName: 'detail' */ '@/views/detail/page.vue') //内容页-详情页
const DetailAlbum = () => import(/* webpackChunkName: 'detail-album' */ '@/views/detail/album.vue') //图集-详情页
const DetailHonor = () => import(/* webpackChunkName: 'detail-honor' */ '@/views/detail/honor.vue') //荣誉成就-详情页
const DetailBusiness = () => import(/* webpackChunkName: 'detail-business' */ '@/views/detail/business.vue') //商务活动-详情页
const DetailCharity = () => import(/* webpackChunkName: 'detail-charity' */ '@/views/detail/charity.vue') //社会公益-详情页
const DetailAmbassador = () => import(/* webpackChunkName: 'detail-ambassador' */ '@/views/detail/ambassador.vue') //品牌代言-详情页
const DetailMovietv = () => import(/* webpackChunkName: 'detail-movietv' */ '@/views/detail/movietv.vue') //影视剧-详情页
const DetailVariety = () => import(/* webpackChunkName: 'detail-variety' */ '@/views/detail/variety.vue') //综艺-详情页
const DetailMusic = () => import(/* webpackChunkName: 'detail-music' */ '@/views/detail/music.vue') //音乐-详情页
// 东娱页面
const DongyuEndorsementWeeklyList = () =>
  import(/* webpackChunkName: 'dongyu-endorsement-weekly-list' */ '@/views/dongyu/endorsement/weekly/list.vue') //东娱一周星闻列表
const DongyuEndorsementWeeklyDetail = () =>
  import(/* webpackChunkName: 'dongyu-endorsement-weekly-detail' */ '@/views/dongyu/endorsement/weekly/detail.vue') //东娱一周星闻详情
const Dongyu = () => import(/* webpackChunkName: 'dongyu' */ '@/views/dongyu/home.vue')
const DongyuListArtist = () => import(/* webpackChunkName: 'dongyu-list-artist' */ '@/views/dongyu/list/artist.vue') //东娱艺人
const DongyuListActivity = () =>
  import(/* webpackChunkName: 'dongyu-list-activity' */ '@/views/dongyu/list/activity.vue') //东娱活动（演唱会，综艺列表）
const DongyuListCase = () => import(/* webpackChunkName: 'dongyu-list-case' */ '@/views/dongyu/list/case.vue') //东娱案例
const DongyuListNew = () => import(/* webpackChunkName: 'dongyu-list-new' */ '@/views/dongyu/list/new.vue') //东娱资讯
const DongyuListCaseLatest = () =>
  import(/* webpackChunkName: 'dongyu-list-case-latest' */ '@/views/dongyu/list/caselatest.vue') //东娱最新案例
const DongyuDetail = () => import(/* webpackChunkName: 'dongyu-detail' */ '@/views/dongyu/detail/page.vue') //东娱详情页
// 子公司页面
const CompanyHme = () => import(/* webpackChunkName: 'company-hme' */ '@/views/company/hme/home.vue')
const CompanyKyyy = () => import(/* webpackChunkName: 'company-kyyy' */ '@/views/company/kyyy/home.vue')
const CompanyMtxh = () => import(/* webpackChunkName: 'company-mtxh' */ '@/views/company/mtxh/home.vue')
const CompanyDyxh = () => import(/* webpackChunkName: 'company-dyxh' */ '@/views/company/dyxh/home.vue')
// H5页面
// 王楚钦抽奖活动
const H5WangchuqinLottery = () =>
  import(/* webpackChunkName: 'h5-wangchuqin-lottery' */ '@/views/h5/wangchuqin/lottery.vue')
// 多哈活动
const H5dhsps = () => import(/* webpackChunkName: 'h5-dhsps' */ '@/views/h5/dhsps/index.vue')
const H5dhspsSuccess = () => import(/* webpackChunkName: 'h5-dhsps-success' */ '@/views/h5/dhsps/success.vue')
const H5dhspsAdmin = () => import(/* webpackChunkName: 'h5-dhsps-admin' */ '@/views/h5/dhsps/admin.vue')
// 临时报名活动
const H5Activity = () => import(/* webpackChunkName: 'h5-activity' */ '@/views/h5/activity/index.vue')
const H5ActivitySuccess = () => import(/* webpackChunkName: 'h5-activity-success' */ '@/views/h5/activity/success.vue')
const H5ActivityAdmin = () => import(/* webpackChunkName: 'h5-activity-admin' */ '@/views/h5/activity/admin.vue')
const H5ActivityList = () => import(/* webpackChunkName: 'h5-activity-list' */ '@/views/h5/activity/list.vue')
// 白皮书
const H5WhiteBook = () => import(/* webpackChunkName: 'h5-white-book' */ '@/views/h5/whitebook/index.vue')
// 盛典预热
const H5Ceremony = () => import(/* webpackChunkName: 'h5-ceremony' */ '@/views/h5/ceremony/index.vue')
const H5CeremonyVote = () =>
  import(/* webpackChunkName: 'h5-ceremony-vote' */ '@/components/mobile/h5/ceremony/vote.vue')
const H5CeremonyInformation = () =>
  import(/* webpackChunkName: 'h5-ceremony-information' */ '@/components/mobile/h5/ceremony/information.vue')
const H5CeremonyConferenceNews = () =>
  import(/* webpackChunkName: 'h5-ceremony-conference-news' */ '@/components/mobile/h5/ceremony/conferenceNews.vue')
const H5CeremonyMediaNews = () =>
  import(/* webpackChunkName: 'h5-ceremony-media-news' */ '@/components/mobile/h5/ceremony/mediaNews.vue')
const H5CeremonyVideoPlay = () =>
  import(/* webpackChunkName: 'h5-ceremony-video-play' */ '@/components/mobile/h5/ceremony/components/VideoPlay.vue')
const H5CeremonyMore = () =>
  import(/* webpackChunkName: 'h5-ceremony-more' */ '@/components/mobile/h5/ceremony/more.vue')
const H5CeremonyCarnival = () =>
  import(/* webpackChunkName: 'h5-ceremony-carnival' */ '@/components/mobile/h5/ceremony/carnival/index.vue')
const H5CeremonyCarnivalPrize = () =>
  import(/* webpackChunkName: 'h5-ceremony-carnival-prize' */ '@/components/mobile/h5/ceremony/carnival/prize.vue')
const H5CeremonyCarnivalOpeningNight = () =>
  import(
    /* webpackChunkName: 'h5-ceremony-carnival-opening-night' */ '@/components/mobile/h5/ceremony/carnival/openingNight.vue'
  )
const H5CeremonyCarnivalThemePopup = () =>
  import(
    /* webpackChunkName: 'h5-ceremony-carnival-theme-popup' */ '@/components/mobile/h5/ceremony/carnival/themePopup.vue'
  )
const H5CeremonyCarnivalThemePopupDetail = () =>
  import(
    /* webpackChunkName: 'h5-ceremony-carnival-theme-popup-detail' */ '@/components/mobile/h5/ceremony/carnival/themePopupDetail.vue'
  )
const H5CeremonyCarnivalInfluenceRecommendation = () =>
  import(
    /* webpackChunkName: 'h5-ceremony-carnival-influence-recommendation' */ '@/components/mobile/h5/ceremony/carnival/influenceRecommendation.vue'
  )
const H5CeremonyCarnivalYouthMarket = () =>
  import(
    /* webpackChunkName: 'h5-ceremony-carnival-youth-market' */ '@/components/mobile/h5/ceremony/carnival/youthMarket.vue'
  )
const H5CeremonyCarnivalInfluenceCeremony = () =>
  import(
    /* webpackChunkName: 'h5-ceremony-carnival-influence-ceremony' */ '@/components/mobile/h5/ceremony/carnival/influenceCeremony.vue'
  )
const H5CeremonyDemo = () =>
  import(/* webpackChunkName: 'h5-ceremony-demo' */ '@/components/mobile/h5/ceremony/demo.vue')
const H5DemoHome = () => import(/* webpackChunkName: 'h5-demo-home' */ '@/views/h5/demo/home.vue')
const H5DemoData = () => import(/* webpackChunkName: 'h5-demo-data' */ '@/views/h5/demo/data.vue')
const H5DemoDataDetail = () => import(/* webpackChunkName: 'h5-demo-data-detail' */ '@/views/h5/demo/dataDetail.vue')
const H5DemoSummary = () => import(/* webpackChunkName: 'h5-demo-summary' */ '@/views/h5/demo/summary.vue')
const H5DemoStarData = () => import(/* webpackChunkName: 'h5-demo-star-data' */ '@/views/h5/demo/starData.vue')
const H5DemoV3Home = () => import(/* webpackChunkName: 'h5-demo-v3-home' */ '@/views/h5/demo/v3/home.vue')
const H5DemoV3FindStar = () => import(/* webpackChunkName: 'h5-demo-v3-find-star' */ '@/views/h5/demo/v3/findStar.vue')
const H5DemoV3Endorsement = () =>
  import(/* webpackChunkName: 'h5-demo-v3-endorsement' */ '@/views/h5/demo/v3/endorsement.vue')
const H5CeremonySelect = () =>
  import(/* webpackChunkName: 'h5-ceremony-select' */ '@/components/mobile/h5/ceremony/select.vue')
const H5CeremonyTicketLottery = () =>
  import(/* webpackChunkName: 'h5-ceremony-ticket-lottery' */ '@/views/h5/ceremony/ticketLottery.vue')
const H5CeremonyTicketLotteryNocode = () =>
  import(/* webpackChunkName: 'h5-ceremony-ticket-lottery-nocode' */ '@/views/h5/ceremony/ticketLotteryNocode.vue')
const H5CeremonyTicketLottery219 = () =>
  import(/* webpackChunkName: 'h5-ceremony-ticket-lottery-219' */ '@/views/h5/ceremony/ticketLottery219.vue')
const H5CeremonyLoginLottery = () =>
  import(/* webpackChunkName: 'h5-ceremony-login-lottery' */ '@/views/h5/ceremony/loginLottery.vue')
const H5CeremonyTicketLotteryActivity = () =>
  import(/* webpackChunkName: 'h5-ceremony-ticket-lottery-activity' */ '@/views/h5/ceremony/ticketLotteryActivity.vue')
const routes = [
  {
    name: 'Error404',
    path: '/error404',
    component: Error404,
  },
  {
    path: '/',
    name: 'home',
    meta: { nav: 'home' },
    component: Home,
  },
  {
    name: 'Test',
    path: '/test',
    component: Test,
  },
  {
    name: 'Search',
    path: '/search',
    component: Search,
  },
  {
    name: 'UserAgreement',
    path: '/agreement',
    meta: { title: '用户协议' },
    component: UserAgreement,
  },
  {
    name: 'PrivacyPolicy',
    path: '/privacy',
    meta: { title: '隐私政策' },
    component: PrivacyPolicy,
  },
  {
    name: 'BusinessInfoBind',
    path: '/business/info',
    meta: { title: '东娱传媒' },
    component: BusinessInfoBind,
  },
  {
    name: 'UserList',
    path: '/user/list',
    meta: { title: '用户列表' },
    component: UserList,
  },
  {
    path: '/personal',
    meta: { nav: 'personalcenter' },
    component: Layouts,
    children: [
      {
        name: 'PersonalCenter',
        path: '/personal/center',
        component: PersonalCenter,
      },
      {
        name: 'PersonalAccountSetting',
        path: 'account/setting',
        component: PersonalAccountSetting,
      },
      {
        name: 'PersonalMySubscribe',
        path: 'my/subscribe',
        component: PersonalMySubscribe,
      },
      {
        name: 'PersonalMyCelebrities',
        path: 'my/celebrities',
        component: PersonalMyCelebrities,
      },
      {
        name: 'PersonalMyPhoto',
        path: 'my/photo',
        component: PersonalMyPhoto,
      },
      {
        name: 'PersonalMyActive',
        path: 'my/active',
        component: PersonalMyActive,
      },
      {
        name: 'PersonalMyStarlight',
        path: 'my/starlight',
        component: PersonalMyStarlight,
      },
      {
        name: 'PersonalNotification',
        path: 'notification',
        component: PersonalNotification,
      },
      {
        name: 'PersonalNotificationSubscribe',
        path: 'notification/subscribe',
        component: PersonalNotificationSubscribe,
      },
      {
        name: 'PersonalNotificationLike',
        path: 'notification/like',
        component: PersonalNotificationLike,
      },
      {
        name: 'PersonalNotificationComment',
        path: 'notification/comment',
        component: PersonalNotificationComment,
      },
    ],
  },
  {
    path: '/community',
    component: Layouts,
    children: [
      {
        name: 'CommunityIndex',
        path: '/community',
        meta: { nav: 'community' },
        component: CommunityIndex,
      },
      {
        name: 'CommunityUserHome',
        path: 'user',
        component: CommunityUserHome,
      },
      {
        name: 'CommunityPublishDaily',
        path: 'publish/daily',
        component: CommunityPublishDaily,
      },
      {
        name: 'CommunityPublishImageReturn',
        path: 'publish/imagereturn',
        component: CommunityPublishImageReturn,
      },
      {
        name: 'CommunityPublishActivityRegistration',
        path: 'publish/activityregistration',
        component: CommunityPublishActivityRegistration,
      },
      {
        name: 'CommunityPublishImageCollection',
        path: 'publish/imagecollection',
        component: CommunityPublishImageCollection,
      },
      {
        name: 'CommunityPublishVote',
        path: 'publish/vote',
        component: CommunityPublishVote,
      },
      {
        name: 'CommunityPublishNewRecruit',
        path: 'publish/newrecruit',
        component: CommunityPublishNewRecruit,
      },
      {
        name: 'CommunityPublishLotteryDraw',
        path: 'publish/lottery',
        component: CommunityPublishLotteryDraw,
      },
      {
        name: 'CommunityPublishCreativeCollection',
        path: 'publish/creativecollection',
        component: CommunityPublishCreativeCollection,
      },
      {
        name: 'CommunityPostDetailActivityRegistration',
        path: 'post/detail/activityregistration',
        component: CommunityPostDetailActivityRegistration,
      },
      {
        name: 'CommunityPostDetailImageCollection',
        path: 'post/detail/imagecollection',
        component: CommunityPostDetailImageCollection,
      },
      {
        name: 'CommunityPostDetailImageReturn',
        path: 'post/detail/imagereturn',
        component: CommunityPostDetailImageReturn,
      },
      {
        name: 'CommunityPostDetailDaily',
        path: 'post/detail/daily',
        component: CommunityPostDetailDaily,
      },
      {
        name: 'CommunityPostDetailCreativeCollection',
        path: 'post/detail/creativecollection',
        component: CommunityPostDetailCreativeCollection,
      },
      {
        name: 'CommunityPostDetailVote',
        path: 'post/detail/vote',
        component: CommunityPostDetailVote,
      },
      {
        name: 'CommunityPostDetailNewRecruit',
        path: 'post/detail/newrecruit',
        component: CommunityPostDetailNewRecruit,
      },
      {
        name: 'CommunityPostDetailLotteryDraw',
        path: 'post/detail/lottery',
        component: CommunityPostDetailLotteryDraw,
      },
      {
        name: 'CommunityAuditImageReturn',
        path: 'audit/imagereturn',
        component: CommunityAuditImageReturn,
      },
      {
        name: 'CommunityAuditActivityRegistration',
        path: 'audit/activityregistration',
        component: CommunityAuditActivityRegistration,
      },
      {
        name: 'CommunityAuditCreativeCollection',
        path: 'audit/creativecollection',
        component: CommunityAuditCreativeCollection,
      },
      {
        name: 'CommunityAuditNewRecruit',
        path: 'audit/newrecruit',
        component: CommunityAuditNewRecruit,
      },
      {
        name: 'CommunityPostListActivityRegistration',
        path: 'post/list/activityregistration',
        component: CommunityPostListActivityRegistration,
      },
      {
        name: 'CommunityPostListImageCollection',
        path: 'post/list/imageCollection',
        component: CommunityPostListImageCollection,
      },
      {
        name: 'CommunityGrandceremony',
        path: 'grandceremony',
        component: CommunityGrandceremony,
      },
    ],
  },
  {
    path: '/ai',
    component: Layouts,
    children: [
      {
        name: 'AiIndex',
        path: '/ai',
        meta: { nav: 'ai' },
        component: AiIndex,
      },
      {
        name: 'AiFinish',
        path: 'finish',
        component: AiFinish,
      },
      {
        name: 'AiTest',
        path: 'buy',
        component: AiTest,
      },
      {
        name: 'AiTemplate',
        path: ':artist',
        component: AiTemplate,
      },
      {
        name: 'AiCreate',
        path: ':artist/create',
        component: AiCreate,
      },
    ],
  },
  {
    path: '/home',
    meta: { nav: 'home' },
    component: Layouts,
    children: [
      {
        name: 'Home',
        path: '/home',
        component: Home,
      },
      {
        name: 'HomeListArtist',
        path: 'list/artist',
        meta: { nav: 'artist' },
        component: HomeListArtist,
      },
      {
        name: 'HomeListAmbassador',
        path: 'list/ambassador',
        meta: { nav: 'ambassador' },
        component: HomeListAmbassador,
      },
      {
        name: 'HomeListActive',
        path: 'list/active',
        meta: { nav: 'active' },
        component: HomeListActive,
      },
      {
        name: 'HomeListRankEndorsement',
        path: 'list/rank/endorsement',
        meta: { nav: 'rank' },
        component: HomeListRankEndorsement,
      },
      {
        name: 'HomeListRankEndorsementTest',
        path: 'list/rank/endorsementtest',
        meta: { nav: 'rank' },
        component: HomeListRankEndorsementTest,
      },
      {
        name: 'HomeDetail',
        path: 'detail',
        component: Detail,
      },
      {
        name: 'HomeDetailEndorsementWeek',
        path: 'detail/endorsement/week',
        meta: { nav: 'endorsement' },
        component: HomeDetailEndorsementWeek,
      },
      {
        name: 'HomeDetailBrand',
        path: 'detail/brand',
        meta: { nav: 'endorsement' },
        component: HomeDetailBrand,
      },
      {
        name: 'HomeDetailEndorsementMonth',
        path: 'detail/endorsement/month',
        meta: { nav: 'endorsement' },
        component: HomeDetailEndorsementMonth,
      },
      {
        name: 'HomeDetailRankEndorsementVolume',
        path: 'detail/rank/endorsement/volume',
        meta: { nav: 'rank' },
        component: HomeDetailRankEndorsementVolume,
      },
      {
        name: 'HomeDetailRankEndorsementAmount',
        path: 'detail/rank/endorsement/amount',
        meta: { nav: 'rank' },
        component: HomeDetailRankEndorsementAmount,
      },
      {
        name: 'HomeDetailRankStarfire',
        path: 'detail/rank/starfire',
        meta: { nav: 'rank' },
        component: HomeDetailRankStarfire,
      },
      {
        name: 'HomeDetailRankStarfireRule',
        path: 'detail/rank/starfire/rule',
        meta: { nav: 'rank' },
        component: HomeDetailRankStarfireRule,
      },
      {
        name: 'HomeDetailRankFlame',
        path: 'detail/rank/flame',
        meta: { nav: 'rank' },
        component: HomeDetailRankFlame,
      },
      {
        name: 'HomeDetailRankFlameRule',
        path: 'detail/rank/flame/rule',
        meta: { nav: 'rank' },
        component: HomeDetailRankFlameRule,
      },
      {
        name: 'HomeListHotspot',
        path: 'list/hotspot',
        meta: { nav: 'hotspot' },
        component: ListHotspot,
      },
      {
        name: 'HomeListMovieTv',
        path: 'list/movietv',
        component: ListMovieTv,
      },
      {
        name: 'HomeListMusic',
        path: 'list/music',
        component: ListMusic,
      },
      {
        name: 'HomeListVariety',
        path: 'list/variety',
        component: ListVariety,
      },
      // {
      //     name: "HomeListCase",
      //     path: 'list/case',
      //     meta: { nav: "case" },
      //     component: ListCase
      // },
      // {
      //     name: "HomeListNew",
      //     path: 'list/new',
      //     meta: { nav: "new" },
      //     component: ListNew
      // },
    ],
  },
  {
    path: '/dongyu',
    meta: { nav: 'dongyu', title: '东娱传媒' },
    component: Layouts,
    children: [
      {
        name: 'Dongyu',
        path: '/dongyu',
        meta: { nav: 'dongyu', title: '东娱传媒' },
        component: Dongyu,
      },
      {
        name: 'DongyuEndorsementWeeklyList',
        path: 'endorsement/weekly/list',
        meta: { nav: 'dongyu', title: '东娱传媒' },
        component: DongyuEndorsementWeeklyList,
      },
      {
        name: 'DongyuEndorsementWeeklyDetail',
        path: 'endorsement/weekly/detail',
        meta: { nav: 'dongyu', title: '东娱传媒' },
        component: DongyuEndorsementWeeklyDetail,
      },
      {
        name: 'DongyuDetail',
        path: 'detail',
        meta: { nav: 'dongyu', title: '东娱传媒' },
        component: DongyuDetail,
      },
      {
        name: 'DongyuListArtist',
        path: 'list/artist',
        meta: { nav: 'dongyu', title: '明星列表' },
        component: DongyuListArtist,
      },
      {
        name: 'DongyuListHotspot',
        path: 'list/hotspot',
        meta: { nav: 'dongyu', title: '东娱传媒' },
        component: ListHotspot,
      },
      {
        name: 'DongyuListAmbassador',
        path: 'list/ambassador',
        meta: { nav: 'dongyu', title: '东娱传媒' },
        component: ListAmbassador,
      },
      {
        name: 'DongyuListMovieTv',
        path: 'list/movietv',
        meta: { nav: 'dongyu', title: '东娱传媒' },
        component: ListMovieTv,
      },
      {
        name: 'DongyuListMusic',
        path: 'list/music',
        meta: { nav: 'dongyu', title: '东娱传媒' },
        component: ListMusic,
      },
      {
        name: 'DongyuListVariety',
        path: 'list/variety',
        meta: { nav: 'dongyu', title: '东娱传媒' },
        component: ListVariety,
      },
      {
        name: 'DongyuListCase',
        path: 'list/case',
        meta: { nav: 'dongyu', title: '东娱传媒' },
        component: DongyuListCase,
      },
      {
        name: 'DongyuListCaseLatest',
        path: 'list/caselatest',
        meta: { nav: 'dongyu', title: '东娱传媒' },
        component: DongyuListCaseLatest,
      },
      {
        name: 'DongyuListNew',
        path: 'list/new',
        meta: { nav: 'dongyu', title: '东娱传媒' },
        component: DongyuListNew,
      },
      {
        name: 'DongyuListActivity',
        path: 'list/activity',
        meta: { nav: 'dongyu', title: '东娱传媒' },
        component: DongyuListActivity,
      },
    ],
  },
  {
    path: '/hme',
    meta: { nav: 'hme', title: '哈米尔动漫' },
    component: Layouts,
    children: [
      {
        name: 'CompanyHme',
        path: '/hme',
        meta: { nav: 'hme', title: '哈米尔动漫' },
        component: CompanyHme,
      },
    ],
  },
  {
    path: '/kyyy',
    meta: { nav: 'kyyy', title: '鲲一影业' },
    component: Layouts,
    children: [
      {
        name: 'CompanyKyyy',
        path: '/kyyy',
        meta: { nav: 'kyyy', title: '鲲一影业' },
        component: CompanyKyyy,
      },
    ],
  },
  {
    path: '/mtxh',
    meta: { nav: 'mtxh', title: '满天星火' },
    component: Layouts,
    children: [
      {
        name: 'CompanyMtxh',
        path: '/mtxh',
        meta: { nav: 'mtxh', title: '满天星火' },
        component: CompanyMtxh,
      },
    ],
  },
  {
    path: '/dyxh',
    meta: { nav: 'dyxh', title: '东娱星与' },
    component: Layouts,
    children: [
      {
        name: 'CompanyDyxh',
        path: '/dyxh',
        meta: { nav: 'dyxh', title: '东娱星与' },
        component: CompanyDyxh,
      },
    ],
  },

  {
    path: '/h5',
    component: Layouts,
    children: [
      {
        name: 'H5dhsps',
        path: 'dhsps',
        component: H5dhsps,
      },
      {
        name: 'H5dhspsSuccess',
        path: 'dhsps/success',
        component: H5dhspsSuccess,
      },
      {
        name: 'H5dhspsAdmin',
        path: 'dhsps/admin',
        component: H5dhspsAdmin,
      },
      {
        name: 'H5WangchuqinLottery',
        path: 'wangchuqin/lottery',
        component: H5WangchuqinLottery,
      },
    ],
  },
  {
    path: '/:artist',
    // meta: { nav: "artist" },
    component: Layouts,
    children: [
      {
        name: 'Artist',
        path: '/:artist',
        component: Artist,
        // meta: { keepAlive: true }
      },
      {
        name: 'ArtistDetail',
        path: 'detail',
        component: Detail,
      },
      {
        name: 'ArtistDetailAlbum',
        path: 'detail/album',
        component: DetailAlbum,
      },
      {
        name: 'ArtistDetailHonor',
        path: 'detail/honor',
        component: DetailHonor,
      },
      {
        name: 'ArtistDetailBusiness',
        path: 'detail/business',
        component: DetailBusiness,
      },
      {
        name: 'ArtistDetailCharity',
        path: 'detail/charity',
        component: DetailCharity,
      },
      {
        name: 'ArtistDetailAmbassador',
        path: 'detail/ambassador',
        component: DetailAmbassador,
      },
      {
        name: 'ArtistDetailMovieTv',
        path: 'detail/movietv',
        component: DetailMovietv,
      },
      {
        name: 'ArtistDetailVariety',
        path: 'detail/variety',
        component: DetailVariety,
      },
      {
        name: 'ArtistDetailMusic',
        path: 'detail/music',
        component: DetailMusic,
      },
      {
        name: 'ArtistListHotspot',
        path: 'list/hotspot',
        component: ListHotspot,
      },
      {
        name: 'ArtistListAmbassador',
        path: 'list/ambassador',
        component: ListAmbassador,
      },
      {
        name: 'ArtistListMovieTv',
        path: 'list/movietv',
        component: ListMovieTv,
      },
      {
        name: 'ArtistListMusic',
        path: 'list/music',
        component: ListMusic,
      },
      {
        name: 'ArtistListVariety',
        path: 'list/variety',
        component: ListVariety,
      },
      // {
      //     name: "ArtistListCase",
      //     path: 'list/case',
      //     component: ListCase
      // },
      {
        name: 'ArtistListImageText',
        path: 'list/imagetext',
        component: ListImageText,
      },
      {
        name: 'ArtistListBusiness',
        path: 'list/business',
        component: ListBusiness,
      },
      {
        name: 'ArtistListBusinessRelate',
        path: 'list/business/relate',
        component: ListBusinessRelate,
      },
      {
        name: 'ArtistListHonor',
        path: 'list/honor',
        component: ListHonor,
      },
      {
        name: 'ArtistListCharity',
        path: 'list/charity',
        component: ListCharity,
      },
      {
        name: 'ArtistListAlbum',
        path: 'list/album',
        component: ListAlbum,
      },
    ],
  },
  {
    path: '/h5',
    component: Layouts,
    children: [
      {
        name: 'H5WangchuqinLottery',
        path: 'wangchuqin/lottery',
        component: H5WangchuqinLottery,
      },
      {
        name: 'H5dhsps',
        path: 'dhsps',
        component: H5dhsps,
      },
      {
        name: 'H5dhspsSuccess',
        path: 'dhsps/success',
        component: H5dhspsSuccess,
      },
      {
        name: 'H5dhspsAdmin',
        path: 'dhsps/admin',
        component: H5dhspsAdmin,
      },
      {
        name: 'H5Activity',
        path: 'activity',
        component: H5Activity,
      },
      {
        name: 'H5ActivitySuccess',
        path: 'activity/success',
        component: H5ActivitySuccess,
      },
      {
        name: 'H5ActivityAdmin',
        path: 'activity/admin',
        component: H5ActivityAdmin,
      },
      {
        name: 'H5ActivityList',
        path: 'activity/list',
        component: H5ActivityList,
      },
      {
        name: 'H5WhiteBook',
        path: 'whitebook',
        component: H5WhiteBook,
      },
      {
        name: 'H5Ceremony',
        path: 'ceremony',
        component: H5Ceremony,
      },
      {
        name: 'H5CeremonyRecommend',
        path: 'ceremony/recommend',
        component: H5Ceremony,
      },
      {
        name: 'H5CeremonyHistory',
        path: 'ceremony/history',
        component: H5Ceremony,
      },
      {
        name: 'H5CeremonyHistoryDirect',
        path: 'ceremony/history-direct',
        component: H5Ceremony,
      },
      {
        name: 'H5CeremonyVote',
        path: 'ceremony/vote',
        component: H5CeremonyVote,
      },
      {
        name: 'H5CeremonyInformation',
        path: 'ceremony/information',
        component: H5CeremonyInformation,
      },
      {
        name: 'H5CeremonyConferenceNews',
        path: 'ceremony/conference-news',
        component: H5CeremonyConferenceNews,
      },
      {
        name: 'H5CeremonyMediaNews',
        path: 'ceremony/media-news',
        component: H5CeremonyMediaNews,
      },
      {
        name: 'H5CeremonyVideoPlay',
        path: 'ceremony/video',
        component: H5CeremonyVideoPlay,
      },
      {
        name: 'H5CeremonyMore',
        path: 'ceremony/more',
        component: H5CeremonyMore,
      },
      {
        name: 'H5CeremonyCarnival',
        path: 'ceremony/carnival',
        meta: { title: '盛典嘉年华' },
        component: H5CeremonyCarnival,
      },
      {
        name: 'H5CeremonyCarnivalPrize',
        path: 'ceremony/carnival/prize',
        meta: { title: '嘉年华奖品' },
        component: H5CeremonyCarnivalPrize,
      },
      {
        name: 'H5CeremonyCarnivalOpeningNight',
        path: 'ceremony/carnival/opening-night',
        meta: { title: '启幕之夜' },
        component: H5CeremonyCarnivalOpeningNight,
      },
      {
        name: 'H5CeremonyCarnivalThemePopup',
        path: 'ceremony/carnival/theme-popup',
        meta: { title: '主题快闪' },
        component: H5CeremonyCarnivalThemePopup,
      },
      {
        name: 'H5CeremonyCarnivalThemePopupDetail',
        path: 'ceremony/carnival/theme-popup/detail',
        meta: { title: '快闪分站详情' },
        component: H5CeremonyCarnivalThemePopupDetail,
      },
      {
        name: 'H5CeremonyCarnivalInfluenceRecommendation',
        path: 'ceremony/carnival/influence-recommendation',
        meta: { title: '影响力推荐' },
        component: H5CeremonyCarnivalInfluenceRecommendation,
      },
      {
        name: 'H5CeremonyCarnivalYouthMarket',
        path: 'ceremony/carnival/youth-market',
        meta: { title: '青春市集' },
        component: H5CeremonyCarnivalYouthMarket,
      },
      {
        name: 'H5CeremonyCarnivalInfluenceCeremony',
        path: 'ceremony/carnival/influence-ceremony',
        meta: { title: '影响力盛典' },
        component: H5CeremonyCarnivalInfluenceCeremony,
      },
      {
        name: 'H5CeremonyDemo',
        path: 'ceremony/demo',
        component: H5CeremonyDemo,
      },
      {
        name: 'H5DemoHome',
        path: 'demo/home',
        component: H5DemoHome,
      },
      {
        name: 'H5DemoData',
        path: 'demo/data',
        component: H5DemoData,
      },
      {
        name: 'H5DemoDataDetail',
        path: 'demo/data-detail',
        component: H5DemoDataDetail,
      },
      {
        name: 'H5DemoSummary',
        path: 'demo/summary',
        component: H5DemoSummary,
      },
      {
        name: 'H5DemoStarData',
        path: 'demo/star-data',
        component: H5DemoStarData,
      },
      {
        name: 'H5DemoV3Home',
        path: 'demo/v3/home',
        component: H5DemoV3Home,
      },
      {
        name: 'H5DemoV3FindStar',
        path: 'demo/v3/find-star',
        component: H5DemoV3FindStar,
      },
      {
        name: 'H5DemoV3Endorsement',
        path: 'demo/v3/endorsement',
        component: H5DemoV3Endorsement,
      },
      {
        name: 'H5CeremonySelect',
        path: 'ceremony/select',
        component: H5CeremonySelect,
      },
      {
        name: 'H5CeremonyTicketLottery',
        path: 'ceremony/ticket-lottery',
        component: H5CeremonyTicketLottery,
      },
      {
        name: 'H5CeremonyTicketLotteryNocode',
        path: 'ceremony/ticket-lottery-nocode',
        component: H5CeremonyTicketLotteryNocode,
      },
      {
        name: 'H5CeremonyTicketLottery219',
        path: 'ceremony/ticket-lottery-219',
        component: H5CeremonyTicketLottery219,
      },
      {
        name: 'H5CeremonyLoginLottery',
        path: 'ceremony/login-lottery',
        component: H5CeremonyLoginLottery,
      },
      {
        name: 'H5CeremonyTicketLotteryActivity',
        path: 'ceremony/ticket-lottery-activity',
        component: H5CeremonyTicketLotteryActivity,
      },
    ],
  },
  {
    path: '*',
    component: () => Error404,
  },
]

export default routes
